var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8336)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8336",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.976784 24.9998C0.976471 23.3736 1.14006 21.7516 1.46507 20.1583C2.09441 17.0854 3.32269 14.1665 5.07981 11.5681C7.68708 7.70575 11.3585 4.68234 15.6492 2.86424C17.1025 2.25002 18.6131 1.78119 20.1587 1.46463C23.3536 0.813874 26.6469 0.813874 29.8418 1.46463C32.9147 2.09397 35.8336 3.32225 38.432 5.07938C42.2943 7.68664 45.3177 11.358 47.1358 15.6487C47.75 17.102 48.2188 18.6125 48.5354 20.1582C49.1861 23.3531 49.1861 26.6465 48.5354 29.8414C47.906 32.9143 46.6778 35.8332 44.9206 38.4315C42.3133 42.2939 38.6418 45.3173 34.351 47.1353C32.8978 47.7495 31.3874 48.2184 29.8418 48.5349C26.6469 49.1857 23.3536 49.1857 20.1587 48.5349C17.0858 47.9056 14.1669 46.6773 11.5686 44.9202C7.70621 42.3129 4.68283 38.6414 2.86477 34.3507C2.25053 32.8975 1.78167 31.387 1.46507 29.8414C1.14005 28.248 0.976463 26.626 0.976784 24.9998ZM29.059 24.8689L17.5443 36.8791L20.0207 39.462L34.012 24.869L20.0207 10.276L17.5443 12.8589L29.0591 24.869L29.059 24.8689Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhiteCircle);
export default __webpack_public_path__ + "static/media/arrow_right_white_circle.ac8fa47c2e9f9d8c63bbf5965ce601d6.svg";
export { ForwardRef as ReactComponent };